import { render, staticRenderFns } from "./LoadingWrapper.vue?vue&type=template&id=770a6c85&scoped=true"
import script from "./LoadingWrapper.vue?vue&type=script&lang=js"
export * from "./LoadingWrapper.vue?vue&type=script&lang=js"
import style0 from "./LoadingWrapper.vue?vue&type=style&index=0&id=770a6c85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770a6c85",
  null
  
)

export default component.exports